export const CREATE_ACTIVITY = `
    mutation createActivity($requestActivite: JSON){
        createActivity(requestActivite: $requestActivite){
            message
            activity {
                id
                description
                entity_type
                status
            }
        }
    }
`;

export const UPDATE_ACTIVITY = `
    mutation updateActivity($requestActivite:JSON){
        updateActivity(requestActivite:$requestActivite){
            message
            activity {
                id
                description
                entity_type
                status
            }
        }
    }
`;
export const DELETE_ACTIVITY = `
    mutation deleteActivity($id:ID){
        deleteActivity(id:$id){
            message
            activity {
                id
                description
                entity_type
                status
            }
        }
    }
`;